<template>
  <div>
    <v-menu
      ref="applicationsFromMenu"
      v-model="applicationsFromMenu"
      :close-on-content-click="false"
      :nudge-right="40"
      :return-value.sync="applicationsDateFrom"
      lazy
      transition="scale-transition"
      offset-y
      full-width
      min-width="290px"
    >
      <template v-slot:activator="{ on }">
        <v-text-field
          v-model="applicationsDateFrom"
          :label="datePickerLabelStart"
          prepend-icon="event"
          readonly
          clearable
          v-on="on"
          @click:clear="clearDate('fromDate')"
        />
      </template>
      <v-date-picker
        v-model="applicationsDateFrom"
        no-title
        scrollable>
        <v-spacer/>
        <v-btn
          flat
          color="primary"
          @click="applicationsFromMenu = false">{{ 'krita.cancel' | translate }}</v-btn>
        <v-btn
          class="primary"
          color="primary"
          @click="filterApplicationsDateFrom">{{ 'krita.ok' | translate }}</v-btn>
      </v-date-picker>
    </v-menu>

    <v-menu
      ref="applicationsToMenu"
      v-model="applicationsToMenu"
      :close-on-content-click="false"
      :nudge-right="40"
      :return-value.sync="applicationsToDate"
      lazy
      transition="scale-transition"
      offset-y
      full-width
      min-width="290px"
    >
      <template v-slot:activator="{ on }">
        <v-text-field
          v-model="applicationsToDate"
          :label="datePickerLabelEnd"
          prepend-icon="event"
          readonly
          clearable
          v-on="on"
          @click:clear="clearDate('toDate')"
        />
      </template>
      <v-date-picker
        v-model="applicationsToDate"
        no-title
        scrollable
        color = "primary">
        <v-spacer/>
        <v-btn
          flat
          color="primary"
          @click="applicationsToMenu = false">{{ 'krita.cancel' | translate }}</v-btn>
        <v-btn
          color="primary"
          class="primary"
          @click="filterApplicationsDateTo">{{ 'krita.ok' | translate }}</v-btn>
      </v-date-picker>
    </v-menu>

    <div id="applicationsFilter">
      <v-btn
        :class="{ secondary: applicationSelection === 'pending' }"
        selection="inProgress"
        color="#3357A0"
        @click="$emit('filterApplications','pending')">{{ 'krita.reports.application.filter.inprogress' | translate }}</v-btn>

      <v-btn
        :class="{ secondary: applicationSelection === 'completed' }"
        selection="completed"
        color="#3357A0"
        @click="$emit('filterApplications','completed')">{{ 'krita.reports.application.filter.completed' | translate }}</v-btn>
      <v-btn
        :class="{ secondary: applicationSelection === 'all' }"
        selection="all"
        color="#3357A0"
        @click="$emit('filterApplications','all')">{{ 'krita.reports.application.filter.all' | translate }}</v-btn>
    </div>
  </div>
</template>

<script>
    export default {
        props: ['applicationSelection'],
        data ()
        {
            return {
                datePickerLabelEnd: this.$t('krita.datepick.enddate'),
                datePickerLabelStart: this.$t('krita.datepick.startdate'),
                applicationsFromMenu: false,
                applicationsToMenu: false,
                applicationsDateFrom: null,
                applicationsToDate: null
            }
        },
        methods: {
            clearDate(target)
            {
                let self = this;

                switch (target) {
                    case 'fromDate':
                        self.applicationsDateFrom = null;
                        break;
                    case 'toDate':
                        self.applicationsToDate = null;
                        break;
                }
                self.$emit('clearDate', target);
            },
            filterApplicationsDateFrom()
            {
                let self = this;
                self.$refs.applicationsFromMenu.save(self.applicationsDateFrom);
                self.applicationsFromMenu = false;
                self.$emit('filterApplicationsDateFrom', self.applicationsDateFrom)
            },
            filterApplicationsDateTo()
            {
                let self = this;
                self.$refs.applicationsToMenu.save(self.applicationsToDate);
                self.applicationsToMenu = false;
                self.$emit('filterApplicationsDateTo', self.applicationsToDate)
            },
        },
    }
</script>
